import styled from '@emotion/styled'

export const PasswordText = styled.p`
  color: #7e7e7e;
  margin-bottom: 6px;
}
`

export const Label = styled.div<{ color: string }>`
  background: ${({ color }) =>
    color === 'error'
      ? 'rgba(219, 1, 0, 0.8)'
      : color === 'warning'
      ? 'rgba(233, 164, 38, 0.8)'
      : color === 'info'
      ? 'rgba(33, 101, 219, 0.8)'
      : color === 'success'
      ? 'rgba(81, 214, 115, 0.8)'
      : 'none'};
  padding: 4px;
  border-radius: 50px;
  height: 28px;
  max-width: 280px;
  margin: 8px 0px;
`

export const LabelText = styled.p`
  color: #fff;
  font-weight: 600;
  font-size: 0.55em;
  text-align: center;
  margin: 3px 0;
`
